<template>
    <div class="content_list_pager">
        <div v-wechat-title="$route.meta.title"></div>
        <div class="column_listser list_columns">
            <el-tabs type="border-card">

                <el-tab-pane :label="columnTitleOne">
                    <ColumnOneList :listerId="idOne"></ColumnOneList>
                </el-tab-pane>

                <el-tab-pane :label="columnTitleTwo">
                    <ColumnTwoList :listerIdTwo="idTwo"></ColumnTwoList>
                </el-tab-pane>

            </el-tabs>
        </div>
    </div>
</template>
<script>
import { listApi , previewAmount , listDetails ,columnNewsList} from '@/api/index'
import ColumnOneList from './columnList/index'
import ColumnTwoList from './columnList/indexTwo'
import Bus from '@/Bus'

const columnParameter = {
    appInfoId: "10",
    parentId: ""
}
const getNewsColumnData = {
    pageNum: 0,
    pageSize: 10,
    columnId: "",
    userId: "",
    appInfoId: "10"
}
export default {
    data(){
        return {
            columnDefine: Object.assign({}, columnParameter),
            getColumnData: Object.assign({}, getNewsColumnData),
            tabPosition: 'left',
            columnTitle: '',
            dataLists:[],
            shareNumber:[],
            total:0,
            previewAmountList:[],
            listTitles : '',
            columnTitleOne:'',
            columnTitleTwo:'',
            idOne:'',
            idTwo:''
        }
    },
    components:{
        ColumnOneList,
        ColumnTwoList
    },
    created(){
        this.columnTitle = this.$route.query.title
        this.getColumnData.columnId = this.$route.query.listId
        if(this.$route.query.listId == '5e3d40cfe4b0a6957ef82267'){
            this.columnTitleOne = '抗击疫情';
            this.columnTitleTwo = '疫情科普';
            this.idOne = '5e3d40cfe4b0a6957ef82267'
            this.idTwo = '5e3d40cfe4b0a6957ef8226a'

        }else if(this.$route.query.listId == '5e804a48e4b027314a1354e9'){
            this.columnTitleOne = '教育动态';
            this.columnTitleTwo = '政策解读';
            this.idOne = '5e804a48e4b027314a1354e9'
            this.idTwo = '5e804a48e4b027314a1354ec'
        }else if(this.$route.query.listId == '14f8ad46-c35c-414c-827f-deff96f54900'){
            this.columnTitleOne = '党的建设';
            this.columnTitleTwo = '主题教育';
            this.idOne = '14f8ad46-c35c-414c-827f-deff96f54900'
            this.idTwo = '5d7ef466e4b0e7a7d72fd4d2'
        }else if(this.$route.query.listId == '5e804a2ce4b027314a1354e5'){
            this.columnTitleOne = '工作纵览';
            this.columnTitleTwo = '健康知识';
            this.idOne = '5e804a6de4b027314a1354f0'
            this.idTwo = '5e804a6de4b027314a1354f3'
        }

    },
    methods:{
     
    }
}
</script>
<style lang="">
    .list_columns .el-tabs--border-card>.el-tabs__content{
        padding:0 !important;
    }
    .column_title{
        height: 18px;
        line-height:18px;
        color: rgba(201,3,4,1);
        font-size: 18px;
        font-weight: bolder;
        margin:0 0 18px 16px;
        padding-left:10px;
        border-left: 3px solid rgba(201,3,4,1);
    }
    .content_list_pager{
        margin-top:20px;
        width:1200px;
        margin:0 auto;
        background:#ffffff;
        padding-top:14px;
    }
    .column_listser{
        min-height:calc(100vh - 351px) !important;
    }
    .column_listser .el-tabs__header{
        background-color:#fff !important;
    }
    .content{
        cursor:pointer; 
        height:146px;
        width: 100%;
        padding-bottom: 76px;
    }
     .content_left{
        width:220px;
        height:145px;
        float:left;
        background:#F7F7F7;
    }
    .content_left img{
        width:100%;
        height:100%;
        border-radius:5px;
    }
    .content_right_nav{
        float:left;
        padding-right:30px;
    }
    .content_right_nav .list_title{
        height:30px;
        line-height: 30px;
    }
    .content_right_nav .list_title img{
        height:24px;
        margin-top:5px;
        float:left;
    }
    .content_right_nav .list_title .list_project{
        background:#D23B2A;
        width:50px;
        margin:5px 5px 0;
        height:24px;
        display:block;
        float:left;
        text-align: center;
        border-radius: 12px;
        font-size:16px;
        line-height:24px;
        color:#ffffff;
    }
    .content_right_nav .list_title .list_tit{
        text-align: left;
        font-family:Source Han Sans CN;
        font-weight:500;
        color:#1A1A1A;
        width:660px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        font-size:20px;
        float:left;
        color:rgba(26,26,26,1);
    }
    .list_number{
        text-align: center;
        padding:1.2rem 0;
    }
   
        .list_cont section{
        display:none !important;
    }
    .list_cont p{
        font-size:14px !important;
        line-height:22px !important;
    }
    .list_cont div img{
        display:none !important;
    }
    .list_cont p img{
        display:none !important;
    }
    .list_cont div{
        font-size:14px !important;
        line-height:22px !important;
    }
    .list_cont p span{
        font-size:14px !important;
        line-height:22px !important;
    }
    .list_cont div span{
        font-size:14px !important;
        line-height:22px !important;
    }
    .list_cont p span img{
        display:none !important;
    }
    .list_cont div span img{
        display:none !important;
    }

    .list_number{
        text-align: center;
        padding:1.2rem 0;
    }
    .content_list_page{
        margin-top:20px;
        width:1200px;
        margin:0 auto;
        -moz-box-shadow:0 0 10px rgb(239, 239, 240);
        -webkit-box-shadow:0 0 10px rgb(206, 206, 209);
        box-shadow:0 0 10px rgb(184, 184, 187);
        background:#ffffff;
    }
    .content_list_navs{
        min-height:calc(100vh - 351px) !important;
       
    }
    .content{
        cursor:pointer; 
        height:146px;
        width: 100%;
        padding-bottom: 76px;
    }
    .content_left{
        width:220px;
        height:145px;
        float:left;
        background:#F7F7F7;
    }
    .content_left img{
        width:100%;
        height:100%;
        border-radius:5px;
    }
    .content_right_nav{
        float:left;
        padding-right:30px;
    }
    .content_right_nav .list_title{
        height:30px;
        line-height: 30px;
    }
    .content_right_nav .list_title img{
        height:24px;
        margin-top:5px;
        float:left;
    }
    .content_right_nav .list_title .list_project{
        background:#D23B2A;
        width:50px;
        margin:5px 5px 0;
        height:24px;
        display:block;
        float:left;
        text-align: center;
        border-radius: 12px;
        font-size:16px;
        line-height:24px;
        color:#ffffff;
    }
    .content_right_nav .list_title .list_tit{
        text-align: left;
        font-family:Source Han Sans CN;
        font-weight:500;
        color:#1A1A1A;
        width:660px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        font-size:20px;
        float:left;
        color:rgba(26,26,26,1);
    }
    .list_content{
        float:left;
        width: 750px;
        height:90px;
        margin-top:25px;
    }
    .list_content .list_cont{
        height:46px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        color:#A1A1A1;
        font-size: 14px;
        line-height:22px;
        padding-top: 10px;
        border-top:1px solid #DCDCDC;
    }
    .list_path{
        width: 750px;
        height:16px;
        line-height:16px;
        padding-top: 20px;
    }
    .list_path .list_path_left{
        float:left;
        font-size:14px;
        color:rgba(180,180,180,1);
    }
    .list_path .list_path_left span{
        padding-right: 16px;
        cursor:pointer;
    }
    .list_path .list_path_right span{
        padding-left: 16px;
        cursor:pointer;
    }
    .list_path .list_path_right span i{
        padding-right: 4px;
        font-size:16px;
    }
    .list_path .list_path_right{
        float:right;
        font-size:14px;
        color:rgba(180,180,180,1);
    }
</style>


// WEBPACK FOOTER //
// src/components/homepage/components/columnAllLists.vue